import { FloorTypes } from '../enums/floorTypes.enum';
import { FinishTypes } from '../enums/finishTypes.enum';
import { SiliconeColours } from '../enums/siliconeColours.enum';

export class PriceSettings {
  public static cornerBeamThicknessToArticles: Record<number, string> = {
    60: 'PRS.000.739',
    80: 'PRS.000.740',
    100: 'PRS.000.741',
    140: 'PRS.000.742',
  };

  public static cornerBeamsThreeSidesToArticleNumbers: Record<number, string> = {
    80: 'PRS.000.743',
    100: 'PRS.000.744',
    140: 'PRS.000.745',
  };

  public static wallCoresToArticleNumbers: Record<number, string> = {
    60: 'KPB.000.405',
    80: 'KPB.000.406',
    100: 'KPB.000.407',
    140: 'KPB.000.408',
  };

  public static wallFinishToArticleNumbers: Record<FinishTypes, string> = {
    [FinishTypes.STEEL]: 'KPB.000.030',
    [FinishTypes.STEEL_PET55]: 'KPB.000.031',
    [FinishTypes.RVS304_LINE_BRUSH]: 'KPB.000.356',
    [FinishTypes.RVS304_COLLED_ROLLED]: 'KPB.000.037',
    [FinishTypes.RVS304_DESIGN_5WL]: 'KPB.000.041',
    [FinishTypes.RVS304_LINEN]: 'KPB.000.039',
    [FinishTypes.RVS304_ROUND_BRUSH]: 'KPB.000.036',
    [FinishTypes.RVS316_ROUND_BRUSH]: 'KPB.000.040',
  };
  public static floorTypesToArticleNumbers: Record<FloorTypes, string> = {
    [FloorTypes.DURAFLOOR]: 'KPB.000.404',
    [FloorTypes.ALUMINUM25]: 'PRS.000.580-ALC1',
    [FloorTypes.ALUMINUM35]: 'PRS.000.580-ALD1',
    [FloorTypes.ANTISLIP]: 'KPB.000.056',
    [FloorTypes.REINFORCEDANTISLIP]: 'PRS.000.580-VLS2',
    [FloorTypes.RVSANTISLIPR13]: 'PRS.000.580-WBPJ',
    [FloorTypes.STEELANTISLIP5]: 'PLA.000.134', // Losse plaat
    [FloorTypes.STEELSMOOTH3]: 'PRS.000.580-VZD1',
    [FloorTypes.NONE]: '',
  };
  public static airPressureEqualizerValve = 'GRS.001.734';
  public static caps: Record<string, string> = {
    white: 'PFA.000.057-Ral 9010',
    black: 'PFA.000.057-Ral 8019',
  };
  public static ventilationProfiles = 'PRF.000.192';
  public static plinths = 'PRF.000.237';
  public static plinthsScrews = 'BEV.000.078';
  public static siliconeToArticleNumbers: Record<SiliconeColours, string> = {
    [SiliconeColours.Bronze]: 'CHM.000.008',
    [SiliconeColours.Transparent]: 'CHM.000.018',
    [SiliconeColours.White]: 'CHM.000.019',
  };
  public static butyl = 'CHM.000.026';
  public static strokePlug = 'BEV.000.158';
  public static washer = 'BEV.000.034';
  public static uProfiles: Record<number, string> = {
    60: 'PRF.000.454',
    80: 'PRF.000.243',
    100: 'PRF.000.244',
  };

  public static uProfilesCorners: Record<number, string> = {
    60: 'PFA.000.352',
    80: 'PFA.000.353',
    100: 'PFA.000.354',
  };

  public static allowedDoorFinishes: FinishTypes[] = [
    FinishTypes.RVS304_LINEN,
    FinishTypes.RVS304_LINE_BRUSH,
    FinishTypes.RVS304_ROUND_BRUSH,
    FinishTypes.RVS316_ROUND_BRUSH,
    FinishTypes.STEEL,
    FinishTypes.STEEL_PET55,
  ];
  public static threeWayCornerByThickness: Record<number, string> = {
    60: 'PRS.000.305',
    80: 'PRS.000.306',
    100: 'PRS.000.307',
    140: 'PRS.000.308',
    180: 'PRS.000.309',
  };
  public static tProfileByThickness: Record<number, string> = {
    60: 'OPT.000.266',
    80: 'OPT.000.266',
    100: 'OPT.000.266',
    140: 'OPT.000.266',
    180: 'OPT.000.266',
  };
  public static lProfileByThickness: Record<number, string> = {
    60: 'PRS.000.512',
    80: 'PRS.000.512',
    100: 'PRS.000.512',
    140: 'PRS.000.512',
    180: 'PRS.000.512',
  };
}
